<template>
  <BreadCrumb PageTitle="Forms" />
  <FormOverview />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import FormOverview from "../../template-components/Forms/FormOverview/FormOverview.vue";

export default defineComponent({
  name: "FormOverviewPage",
  components: {
    BreadCrumb,
    FormOverview,
  },
});
</script>